import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  withCredentials: false,
  timeout: 120000,
  paramsSerializer: (params) => {
    return Object.keys(params)
      .map(key => {
        const value = typeof params[key] === 'object' 
          ? JSON.stringify(params[key]) 
          : params[key];
        return `${key}=${encodeURIComponent(value)}`;
      })
      .join('&');
  }
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  } else {
    config.headers.authorization = 'Bearer anonymous';
  }
  return config;
});

export { axiosInstance };
export default axiosInstance;